import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import './polyfills'
import 'webcrypto-shim'
import 'core-js'
import { App } from './App'
import { buildHeaders } from './lib/buildHeaders'
import { getTealiumUrl } from './shared/constants'
import { ScrollToTop } from './shared/ScrollToTop'
import { store } from './store'

buildHeaders()

window.travURI = '/claimuploadcenter/'

const link = document.createElement('link')
link.rel = 'stylesheet'

if (process.env.NODE_ENV === 'development') {
  link.href = 'https://travelers-dev1.dev.travelers.com/media-assets/fonts/2.0/allfonts.css'
} else {
  link.href = 'https://cdn.travelers.com/fonts/2.1/allfonts.min.css'
}

document.head.appendChild(link)

const teaUrl = getTealiumUrl(window.location.hostname)
const teaElement = document.createElement('script')
teaElement.src = teaUrl
teaElement.type = 'text/javascript'
teaElement.async = true
document.head.appendChild(teaElement)

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </Provider>
)
